<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    title="正在导出"
  >
    <i v-if="status === 1" class="el-icon-loading"></i>
    <i v-if="status === 2" class="el-icon-success" style="color: #008a00"></i>
    <i v-if="status === 3" class="el-icon-warning" style="color: #f8051b"></i>
    <div style="display: inline-block; width: 90%; padding-left: 10px">
      <el-progress :percentage="progress"></el-progress>
    </div>
    <div style="margin-top: 10px; text-align: center">{{ prompt }}</div>
    <div v-if="status === 3" style="margin-top: 10px; text-align: center">
      <el-button type="text" @click="dialogVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
/**
 * 导出dialog组件，用于导出过程的百分比显示
 * 用于解决导出进度的问题
 */
export default {
  name: 'ExportProgress',
  data() {
    return {
      dialogVisible: false,
      progress: 0,
      mission: '',
      status: 1,
    };
  },
  computed: {
    prompt() {
      switch (this.status) {
        case 1:
          return '文件正在导出，请稍等...';
        case 2:
          return '文件导出成功！';
        case 3:
          return '文件导出失败';
        default:
          return '文件正在导出，请稍等...';
      }
    },
  },
  watch: {
    dialogVisible: {
      handler(val) {
        if (!val) {
          setTimeout(() => {
            this.resetProgress();
          }, 300);
        }
      },
    },
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setProgress(val) {
      if (val >= 0 && val <= 100) {
        this.progress = Number.parseInt(val, 10);
      }
    },
    startRidiculousProgress(time) {
      // 设置一个大概完成时间(单位：秒)，让进度条盲目的前进，进度会一直前进并卡在99%
      this.mission = setInterval(() => {
        if (this.progress >= 99) {
          clearInterval(this.mission);
          return;
        }
        this.progress += 1;
      }, time * 10);
    },
    finishProgress(waiting) {
      // 调用后会将进度设为100%，显示导出成功
      // waiting为自动关闭dialog的等待时间（毫秒），下同
      clearInterval(this.mission);
      this.setProgress(100);
      this.status = 2;
      if (waiting) {
        setTimeout(() => {
          this.closeDialog();
        }, waiting);
      }
    },
    abortProgress(waiting) {
      // 调用后会显示失败
      clearInterval(this.mission);
      this.status = 3;
      if (waiting) {
        setTimeout(() => {
          this.closeDialog();
        }, waiting);
      }
    },
    resetProgress() {
      // 调用后会重设进度和状态
      clearInterval(this.mission);
      this.setProgress(0);
      this.status = 1;
    },
  },
};
</script>

<style scoped></style>
